import { getDoc, getDocs } from 'firebase/firestore/lite'
import refs from '../refsLite'

/**
 * Get all the OAuth2 token for a user.  These are documents that are only accessible
 * to the individual user who owns it.
 *
 * @param userId - The user's firebase ID.
 * @returns {Promise<unknown>}
 */
export async function getOauth2Tokens(userId) {
  const snaps = await getDocs(refs.oauth2Tokens(userId))
  const result = {}
  snaps.forEach((snap) => {
    const data = snap.data()
    if (data) {
      result[snap.id] = data
    }
  })

  return result
}
